import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'

import { Observable, of } from 'rxjs'

import { AuthService } from '../auth/services/auth.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    // console.log(`[AuthGuard] Activating guard for path: '${state.url}'`)

    try {
      const isLoggedIn = this.authService.isLoggedIn()
      // console.log(`[AuthGuard] AuthService.isLoggedIn() returned: ${isLoggedIn}`)

      if (isLoggedIn) {
        // console.log('[AuthGuard] Access GRANTED.')
        return of(true)
      } else {
        // console.log('[AuthGuard] Access DENIED. Redirecting to /auth.')
        const reason = this.authService.getToken()
          ? this.authService.isTokenExpired()
            ? 'session_expired'
            : 'invalid_session'
          : 'no_token'
        const urlTree = this.router.createUrlTree(['/auth'], { queryParams: { reason } })
        return of(urlTree)
      }
    } catch (error) {
      console.error('[AuthGuard] An unexpected error occurred:', error)
      // In case of any error, always deny access and redirect.
      const urlTree = this.router.createUrlTree(['/auth'], { queryParams: { reason: 'error' } })
      return of(urlTree)
    }
  }
}
